import {
  createRouter,
  createWebHistory
} from "vue-router";

// 本项目是使用的createWebHistory 模式，不能改为hash模式  因为目前线上正在使用中
const routes = [{
  path: "/h5/sdk",
  meta: {
    title: "第三方信息共享服务商清单",
  },
  component: () => import("../pages/sdk"),
},
{
  path: "/commonh5/sdk",
  meta: {
    title: "第三方信息共享服务商清单",
  },
  component: () => import("../pages/sdk"),
},
{
  path: "/h5/personal_info",
  meta: {
    title: "个人信息收集清单",
  },
  component: () => import("../pages/personal_info"),
},
{
  path: "/commonh5/personal_info",
  meta: {
    title: "个人信息收集清单",
  },
  component: () => import("../pages/personal_info"),
},
];

const router = createRouter({
  routes,
  history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (
    (to.path === "/h5/sdk" || to.path === "/commonh5/sdk") &&
    Object.keys(to.query).length === 0
  ) {
    next(false); // 取消路由导航
  } else {
    next(); // 正常导航
  }
});

export default router;